import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { GCADANavigationComponent } from './navigation.component';
import { GCADANavVerticalItemComponent } from './vertical/item/item.component';
import { GCADANavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { GCADANavVerticalGroupComponent } from './vertical/group/group.component';

@NgModule({
    imports     : [
        CommonModule,
        RouterModule,

        MatIconModule,
        MatRippleModule,

        TranslateModule.forChild()
    ],
    exports     : [
        GCADANavigationComponent
    ],
    declarations: [
        GCADANavigationComponent,
        GCADANavVerticalGroupComponent,
        GCADANavVerticalItemComponent,
        GCADANavVerticalCollapsableComponent
    ]
})
export class GCADANavigationModule
{
}
